import React from 'react';
import { useEffect, useState } from 'react';
import moment from 'moment/moment';
import './RefLetter.css';

const RefLetter = () => {

  const [data, setData] = useState([]);
  const [status, setStatus] = useState("Pending");
  console.warn(status);

  useEffect(() => {
    getRefLetterData();
  }, [])

  const getRefLetterData = async () => {
    const res = await fetch("https://server.archanatusharpatil.in/refLetter",{
   // const res = await fetch("http://localhost:5000/refLetter", {
      headers: {
        authorization: JSON.parse(localStorage.getItem("token"))
      }
    });
    const result = await res.json();
    console.warn(result);
    setData(result);
  }

  const updateStatus = async (id) => {
    const res = await fetch(`https://server.archanatusharpatil.in/refLetter/${id}`,{
    // const res = await fetch(`http://localhost:5000/refLetter/${id}`, {
      method: "PUT",
      body: JSON.stringify({ status }),
      headers: {
        'Content-Type': 'application/json',
        authorization: JSON.parse(localStorage.getItem("token"))
      }
    });
    const result = await res.json();
    getRefLetterData();
  }

  return (
    <>
      <div className="ref-table-container conatainer-flued">
        <h1>Reference Letter List</h1>
        <table>
          <thead className='table-head'>
            <tr>
              <th>Name</th>
              <th>Email</th>
              <th>Date</th>
              <th>Text</th>
              <th>Status</th>
              <th>Select Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {

              data.length != "0" ?
                data?.map((item) => {
                  return (
                    <>
                      <tr>
                        <td>{item.name}<br />{item.mobile}</td>
                        <td>{item.email}</td>
                        <td>{moment(item.date).format("DD-MM-YYYY  hh:mm:ss")}</td>
                        <td>{item.pattern}</td>
                        <td>
                          {item.status}
                        </td>
                        <td><select onChange={(e) => setStatus(e.target.value)}>
                          <option value="Pending">Pending</option>
                          <option value="Ready">Ready</option>
                          <option value="Delivered">Delivered</option>
                        </select></td>
                        <td><button className='update-btn' onClick={() => updateStatus(item.id)}>Update</button></td>
                      </tr>
                    </>
                  )
                })
                :
                <h1>Loading...</h1>
            }
          </tbody>
        </table>
      </div>
    </>
  )
}

export default RefLetter